import { useState, useEffect, useRef } from 'react';
import { getExpedientId, isSameExpedient } from '../utils/assignmentUtils';

/**
 * Hook to manage expedient selection and socket room management
 */
export const useExpedientSelection = (socket, expedientsList) => {
  const [selectedExpedient, setSelectedExpedient] = useState(null);
  const socketRef = useRef(socket);

  // Update socket reference when it changes
  useEffect(() => {
    socketRef.current = socket;
  }, [socket]);

  // Update selected expedient when list changes
  useEffect(() => {
    if (selectedExpedient && expedientsList) {
      const updatedExpedient = expedientsList.find(exp => isSameExpedient(exp, selectedExpedient));
      if (updatedExpedient) {
        setSelectedExpedient(updatedExpedient);
      }
    }
  }, [expedientsList, selectedExpedient]);

  // Function to join an expedient room
  const joinExpedientRoom = expedientId => {
    const currentSocket = socketRef.current;
    if (currentSocket && currentSocket.connected) {
      currentSocket.emit('join_expedient', expedientId);
    } else {
      console.log('Socket not connected, cannot join room');
    }
  };

  // Function to leave an expedient room
  const leaveExpedientRoom = expedientId => {
    const currentSocket = socketRef.current;
    if (currentSocket && currentSocket.connected) {
      currentSocket.emit('leave_expedient', expedientId);
    } else {
      console.log('Socket not connected, cannot leave room');
    }
  };

  // Handle expedient selection
  const handleExpedientSelect = expedient => {
    if (selectedExpedient && isSameExpedient(selectedExpedient, expedient)) {
      return; // Already selected
    }

    // Leave previous room
    if (selectedExpedient) {
      const prevExpedientId = getExpedientId(selectedExpedient);
      leaveExpedientRoom(prevExpedientId);
    }

    // Join new room
    const expedientId = getExpedientId(expedient);
    setSelectedExpedient(expedient);
    joinExpedientRoom(expedientId);
  };

  return {
    selectedExpedient,
    setSelectedExpedient,
    handleExpedientSelect,
    joinExpedientRoom,
    leaveExpedientRoom,
  };
};

